import { useState, useCallback, useEffect } from "react";
import "./productCatelog.css";
/* import { useFetch } from "../hooks/useFetch"; */
/* import { getProducts, getStores } from "../data/api"; */

import ProductModal from "./ProductModal";
import { useSelector } from "react-redux";
import { fetchProductForUserUrl } from "../../api/endpoints";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert";
import Template from "../Template";
import ProductCatalogueFilter from "./ProductFIlter";
import Loader from "../../components/uxCollections/storelensSpiner/StorelenseSpinner";

const PER = 25;

export function SearchBar({ placeholder, value, onChange }) {
  return (
    <div className='search-bar'>
      <i className='ti ti-search' />
      <input placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
}

export function Pagination({ current, total, onChange }) {
  if (total <= 1) return null;
  const pages = [];
  pages.push(1);
  if (current > 3) pages.push("…");
  for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) pages.push(i);
  if (current < total - 2) pages.push("…");
  if (total > 1) pages.push(total);
  return (
    <div className='pagination'>
      <span className='page-info'>
        {current} / {total}
      </span>
      <button className='page-btn' onClick={() => onChange(current - 1)} disabled={current === 1}>
        ‹
      </button>
      {pages.map((p, i) =>
        p === "…" ? (
          <span key={`e${i}`} style={{ color: "var(--text3)", padding: "0 3px", fontSize: 12 }}>
            …
          </span>
        ) : (
          <button key={p} className={`page-btn${current === p ? " active" : ""}`} onClick={() => onChange(p)}>
            {p}
          </button>
        ),
      )}
      <button className='page-btn' onClick={() => onChange(current + 1)} disabled={current === total}>
        ›
      </button>
    </div>
  );
}

export default function ProductsPage({ userSocket }) {
  const [products, setProducts] = useState([]);
  const [pLoading, setPLoading] = useState(true);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [cat, setCat] = useState("All");
  const [storeFilter, setStoreFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [viewProduct, setViewProduct] = useState(null);
  const [totalProducts, setTotalProducts] = useState(0);

  const { user } = useSelector((state) => state.webStoreUser);
  const currency = user.userCountryCurrencySymbol;
  useEffect(() => {
    fetchProducts(page);
  }, []);

  const allProducts = Array.isArray(products) ? products : [];
  const allStores = Array.isArray(user.store) ? user.store : [];

  const filtered = allProducts.filter((p) => {
    const q = search.toLowerCase();

    const ms =
      !q ||
      p.name?.toLowerCase().includes(q) ||
      p.storeName?.toLowerCase().includes(q) ||
      (p.brand || "").toLowerCase().includes(q) ||
      (p.scannedID || "").toLowerCase().includes(q);

    const mCat = cat === "All" || p.productCategory === cat;

    const mStore = storeFilter === "all" || p.storeID?.toString() === storeFilter?.toString();

    const mStatus =
      statusFilter === "all" ||
      (statusFilter === "low" && p.quantity <= p.stockLimit) ||
      (statusFilter === "sale" && p.onSales) ||
      (statusFilter === "damaged" && p.damagedAmount > 0) ||
      (statusFilter === "subunit" && p.hasSubUnits);

    return ms && mCat && mStore && mStatus;
  });

  const lowStockCount = allProducts.filter((p) => p.quantity <= p.stockLimit).length;

  const onSaleCount = allProducts.filter((p) => p.onSales).length;

  const fetchProducts = async (pageNo = 1) => {
    try {
      setPLoading(true);

      const url = `${fetchProductForUserUrl}/${user._id}?page=${pageNo}&limit=${PER}`;

      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      const resData = await res.json();

      if (res.status === 404) {
        uiAlert(res.message || "Your product catelog is empty", "info");
        return;
      }

      if (!res.ok) {
        throw new Error(resData.message || "Failed to fetch products");
      }

      const { products, pagination, message } = resData;

      setProducts(products || []);
      setTotalPages(pagination?.totalPages || 1);
      setPage(pagination?.page || 1);
      setTotalProducts(pagination?.total || 0);
      return;
    } catch (err) {
      console.error(err);
      return uiAlert("Failed to fetch products. Please try again.", "error");
    } finally {
      setPLoading(false);
    }
  };

  if (pLoading)
    return (
      <Template>
        {/* <ProductsSkeleton /> */}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "calc(100vh - 160px)" }}>
          <Loader size={70} />
        </div>
      </Template>
    );

  return (
    <Template>
      <div>
        {/* ── Header ── */}
        {/* <div className='pp__header'>
          <div>
            <div className='pp__title'>Product Catalogue</div>
            <div className='pp__sub'>
              {totalProducts} products · {lowStockCount} low stock · {onSaleCount} on sale
            </div>
          </div>
          <button
            onClick={() => {
              setDrawerOpen(true);
            }}
            className='pp__stats-insight-btn'
          >
            <div className='pp__stats-insight-btn-left'>
              <i className='ti ti-chart-bar' style={{ fontSize: 16, color: "var(--blue)" }} />
              <span>Insights</span>
            </div>
          </button>
        </div> */}

        {/* ── Stat cards — desktop/tablet ── */}

        {/* ── Category chips ── */}
        {/*    <div className='pp__cats'>
          {CATS.map((c) => (
            <button
              key={c}
              className={`pp__cat${cat === c ? " pp__cat--active" : ""}`}
              onClick={() => {
                setCat(c);
                setPage(1);
              }}
            >
              {c}
            </button>
          ))}
        </div> */}
        <ProductCatalogueFilter
          openInsights={() => {
            setDrawerOpen(true);
          }}
          totalProducts={totalProducts}
          lowStockCount={lowStockCount}
          onSaleCount={onSaleCount}
          search={search}
          setSearch={setSearch}
          storeFilter={storeFilter}
          setStoreFilter={setStoreFilter}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          stores={allStores}
          userSocket={userSocket}
        />

        {/* ── Toolbar ── */}
        {/* <div className='pp__toolbar'>
          <SearchBar
            placeholder='Name, brand, barcode, store...'
            value={search}
            onChange={(v) => {
              setSearch(v);
              setPage(1);
            }}
          />
          <select
            className='select'
            value={storeFilter}
            onChange={(e) => {
              setStoreFilter(e.target.value);
              setPage(1);
            }}
          >
            <option value='all'>All stores</option>
            {allStores.slice(0, 14).map((s) => (
              <option key={s._id} value={s._id}>
                {s.storeName}
              </option>
            ))}
          </select>
          <select
            className='select'
            value={statusFilter}
            onChange={(e) => {
              setStatusFilter(e.target.value);
              setPage(1);
            }}
          >
            {STATUS_OPTS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
          <div className='pp__toolbar-right'>
            <span className='pp__count'>{filtered.length} products</span>
          </div>
        </div> */}

        {/* ── Desktop / tablet table ── */}
        <div className='pp__table-outer'>
          <div className='pp__table-scroll'>
            <table className='pp__table'>
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Category</th>
                  <th>Stock</th>
                  <th className='pp__col-cost'>Cost Price</th>
                  <th>Sell Price</th>
                  <th>Margin</th>
                  <th className='pp__col-sold'>Sold (all-time)</th>
                  <th>Store</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((p) => {
                  const lowStock = p.quantity <= p.stockLimit;
                  const margin = p.unitPrice && p.costPrice ? Math.round(((p.unitPrice - p.costPrice) / p.unitPrice) * 100) : 0;
                  const marginCls = margin > 25 ? "pp__margin--high" : margin > 10 ? "pp__margin--mid" : "pp__margin--low";
                  return (
                    <tr key={p._id} onClick={() => setViewProduct(p)}>
                      <td>
                        <div className='pp__cell'>
                          <div className='pp__cell-icon'>
                            <i className='ti ti-package' />
                          </div>
                          <div>
                            <div className='pp__cell-name'>{p.name}</div>
                            <div className='pp__cell-meta'>
                              {p.brand && <span className='pp__cell-brand'>{p.brand}</span>}
                              {p.hasSubUnits && <span className='pp__badge pp__badge--subunit'>Sub-units</span>}
                              {p.scannedID && <span className='pp__cell-barcode'>{p.scannedID}</span>}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className='pp__chip'>{p.productCategory}</span>
                      </td>
                      <td>
                        <div className='pp__stock'>
                          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                            <span className={`pp__stock-num${lowStock ? " pp__stock-num--low" : ""}`}>{p.quantity}</span>
                            {lowStock && (
                              <span className='pp__badge pp__badge--low pp__badge-low' style={{ fontSize: 9 }}>
                                Low
                              </span>
                            )}
                          </div>
                          {p.damagedAmount > 0 && (
                            <div className='pp__stock-damage'>
                              <i className='ti ti-alert-circle' style={{ fontSize: 9 }} />
                              {p.damagedAmount} dmg
                            </div>
                          )}
                        </div>
                      </td>
                      <td className='pp__col-cost'>
                        <span className='pp__price pp__price--cost'>
                          {currency}
                          {p.costPrice.toLocaleString()}
                        </span>
                      </td>
                      <td>
                        <div className={`pp__price${p.onSales ? " pp__price--sale" : " pp__price--reg"}`}>
                          ₦{(p.onSales ? p.discountPrice : p.unitPrice).toLocaleString()}
                        </div>
                        {p.onSales && (
                          <div className='pp__price-strike'>
                            {currency}
                            {p.unitPrice.toLocaleString()}
                          </div>
                        )}
                      </td>
                      <td>
                        <span className={`pp__margin ${marginCls}`}>{margin}%</span>
                      </td>
                      <td className='pp__col-sold'>
                        <span className='pp__price pp__price--reg'>{p.soldAmountAllTime?.toLocaleString()}</span>
                      </td>
                      <td style={{ fontSize: 11, maxWidth: 130, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.storeName}</td>
                      <td>
                        <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                          {p.onSales ? (
                            <span className='pp__badge pp__badge--sale'>
                              <i className='ti ti-tag' />
                              Sale
                            </span>
                          ) : (
                            <span className='pp__badge pp__badge--regular'>Regular</span>
                          )}
                          {p.canBeDelivered && (
                            <span className='pp__badge pp__badge--delivery'>
                              <i className='ti ti-truck' />
                            </span>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
                {!filtered.length && (
                  <tr>
                    <td colSpan={9}>
                      <div className='pp__empty'>
                        <i className='ti ti-package' />
                        <p>No products found</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── Mobile card list ── */}
        <div className='pp__card-list'>
          {filtered.length === 0 ? (
            <div className='pp__empty'>
              <i className='ti ti-package' />
              <p>No products found</p>
            </div>
          ) : (
            filtered.map((p) => {
              const lowStock = p.quantity <= p.stockLimit;
              const margin = p.unitPrice && p.costPrice ? Math.round(((p.unitPrice - p.costPrice) / p.unitPrice) * 100) : 0;
              const marginCls = margin > 25 ? "pp__margin--high" : margin > 10 ? "pp__margin--mid" : "pp__margin--low";
              const stockPct = Math.min(100, Math.round((p.quantity / Math.max(p.quantity, p.stockLimit * 3)) * 100));
              const stockColor = lowStock ? "var(--red)" : stockPct < 60 ? "var(--amber)" : "var(--teal)";

              return (
                <div key={p._id} className='pp__card' onClick={() => setViewProduct(p)}>
                  <div className='pp__card-icon'>
                    <i className='ti ti-package' />
                  </div>
                  <div className='pp__card-body'>
                    <div className='pp__card-name'>{p.name}</div>
                    <div className='pp__card-sub'>
                      <span className='pp__chip' style={{ fontSize: 10 }}>
                        {p.productCategory}
                      </span>
                      {p.brand && <span>{p.brand}</span>}
                      {p.hasSubUnits && (
                        <span className='pp__badge pp__badge--subunit' style={{ fontSize: 9 }}>
                          Sub-units
                        </span>
                      )}
                      {p.onSales && (
                        <span className='pp__badge pp__badge--sale' style={{ fontSize: 9 }}>
                          <i className='ti ti-tag' />
                          Sale
                        </span>
                      )}
                    </div>

                    <div className='pp__card-prices'>
                      <div className='pp__price-item'>
                        <span className='pp__price-lbl'>Sell</span>
                        <span className='pp__price-val' style={{ color: p.onSales ? "var(--amber)" : "var(--teal)" }}>
                          {currency}
                          {(p.onSales ? p.discountPrice : p.unitPrice).toLocaleString()}
                        </span>
                      </div>
                      <div className='pp__price-item'>
                        <span className='pp__price-lbl'>Cost</span>
                        <span className='pp__price-val' style={{ color: "var(--text3)" }}>
                          {currency}
                          {p.costPrice.toLocaleString()}
                        </span>
                      </div>
                      <div className='pp__price-item'>
                        <span className='pp__price-lbl'>Margin</span>
                        <span className={`pp__price-val pp__margin ${marginCls}`}>{margin}%</span>
                      </div>
                    </div>

                    <div className='pp__card-footer'>
                      <div>
                        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                          <span style={{ fontSize: 12, fontWeight: 600, color: stockColor }}>{p.quantity} in stock</span>
                          {lowStock && (
                            <span className='pp__badge pp__badge-low pp__badge--low' style={{ fontSize: 9 }}>
                              Low
                            </span>
                          )}
                          {p.damagedAmount > 0 && <span style={{ fontSize: 11, color: "var(--red)" }}>{p.damagedAmount} dmg</span>}
                        </div>
                        <div className='pp__stock-bar'>
                          <div className='pp__stock-fill' style={{ width: `${stockPct}%`, background: stockColor }} />
                        </div>
                      </div>
                      <div className='pp__card-right'>
                        <span className='pp__card-meta-txt'>{p.storeName?.split(" ").slice(0, 2).join(" ")}</span>
                        <span className='pp__card-meta-txt'>Sold: {p.soldAmountAllTime}</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

        <Pagination current={page} total={totalPages} onChange={fetchProducts} />

        {viewProduct && <ProductModal product={viewProduct} onClose={() => setViewProduct(null)} currency={currency} />}
        {drawerOpen && (
          <InsightsDrawer
            onClose={() => setDrawerOpen(false)}
            allProducts={allProducts}
            totalProducts={totalProducts}
            lowStockCount={lowStockCount}
            onProductClick={(p) => {
              setViewProduct(p);
              setDrawerOpen(false);
            }}
            drawerOpen={drawerOpen}
            onSaleCount={onSaleCount}
          />
        )}
      </div>
    </Template>
  );
}

const shimmer = `
  @keyframes pcs-shimmer {
    0% { background-position: -600px 0; }
    100% { background-position: 600px 0; }
  }
`;

const bone = {
  background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
  backgroundSize: "600px 100%",
  animation: "pcs-shimmer 1.4s infinite linear",
  borderRadius: 6,
};

const Bone = ({ w, h = 14, style = {} }) => <div style={{ ...bone, width: w, height: h, flexShrink: 0, ...style }} />;

const SkeletonRow = ({ isMobile }) => {
  if (isMobile) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: 12,
          padding: "14px 16px",
          borderBottom: "1px solid #f0f2f5",
        }}
      >
        {/* Icon */}
        <div style={{ ...bone, width: 36, height: 36, borderRadius: 8, flexShrink: 0 }} />

        <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 8 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Bone w={120} h={13} />
            <Bone w={56} h={22} style={{ borderRadius: 20 }} />
          </div>
          <Bone w={90} h={11} />
          <div style={{ display: "flex", gap: 8, marginTop: 2 }}>
            <Bone w={64} h={20} style={{ borderRadius: 20 }} />
            <Bone w={48} h={11} style={{ alignSelf: "center" }} />
          </div>
          <div style={{ display: "flex", gap: 20, marginTop: 2 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <Bone w={50} h={10} />
              <Bone w={60} h={13} />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <Bone w={50} h={10} />
              <Bone w={70} h={13} />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <Bone w={40} h={10} />
              <Bone w={36} h={13} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "2fr 1.2fr 0.7fr 1fr 1fr 0.8fr 1fr 1fr 0.9fr",
        alignItems: "center",
        gap: 12,
        padding: "16px 20px",
        borderBottom: "1px solid #f0f2f5",
      }}
    >
      {/* Product col */}
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ ...bone, width: 36, height: 36, borderRadius: 8, flexShrink: 0 }} />
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <Bone w={100} h={13} />
          <Bone w={130} h={11} />
        </div>
      </div>
      {/* Category */}
      <Bone w={90} h={26} style={{ borderRadius: 20 }} />
      {/* Stock */}
      <Bone w={40} h={13} />
      {/* Cost price */}
      <Bone w={60} h={13} />
      {/* Sell price */}
      <Bone w={70} h={13} />
      {/* Margin */}
      <Bone w={36} h={13} />
      {/* Sold */}
      <Bone w={30} h={13} />
      {/* Store */}
      <Bone w={80} h={13} />
      {/* Status */}
      <Bone w={60} h={26} style={{ borderRadius: 20 }} />
    </div>
  );
};

export function ProductsSkeleton() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <style>{shimmer}</style>

      <div style={{ fontFamily: "Nunito, sans-serif" }}>
        {/* Header section */}
        <div
          style={{
            background: "#ffffff",
            border: "1px solid #e8eef5",
            borderRadius: 12,
            padding: isMobile ? "14px 16px" : "16px 20px",
            marginBottom: 16,
          }}
        >
          {/* Title row */}
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              marginBottom: 14,
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <Bone w={160} h={18} />
              <Bone w={220} h={12} />
            </div>
            {/* Insights button */}
            <Bone w={isMobile ? 80 : 100} h={34} style={{ borderRadius: 8 }} />
          </div>

          {/* Search + filter row */}
          <div style={{ display: "flex", gap: 8 }}>
            <Bone w='100%' h={38} style={{ borderRadius: 8, flex: 1 }} />
            <Bone w={38} h={38} style={{ borderRadius: 8, flexShrink: 0 }} />
          </div>
        </div>

        {/* Table */}
        <div
          style={{
            background: "#ffffff",
            border: "1px solid #e8eef5",
            borderRadius: 12,
            overflow: "hidden",
          }}
        >
          {/* Table header — desktop only */}
          {!isMobile && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "2fr 1.2fr 0.7fr 1fr 1fr 0.8fr 1fr 1fr 0.9fr",
                gap: 12,
                padding: "12px 20px",
                borderBottom: "1px solid #e8eef5",
                background: "#f8fafc",
              }}
            >
              {["PRODUCT", "CATEGORY", "STOCK", "COST PRICE", "SELL PRICE", "MARGIN", "SOLD (ALL-TIME)", "STORE", "STATUS"].map((col) => (
                <Bone key={col} w={col === "PRODUCT" ? 60 : 50} h={11} />
              ))}
            </div>
          )}

          {/* Rows */}
          {Array.from({ length: isMobile ? 6 : 10 }).map((_, i) => (
            <SkeletonRow key={i} isMobile={isMobile} />
          ))}
        </div>
      </div>
    </>
  );
}

const InsightsDrawer = ({ onClose, allProducts, totalProducts, lowStockCount, drawerOpen, onSaleCount }) => {
  const stats = [
    { label: "Total Products", val: totalProducts, color: "var(--text)", subLabel: "in catalogue" },
    { label: "Low Stock", val: lowStockCount, color: "var(--red)", subLabel: "below stock limit" },
    { label: "On Sale", val: onSaleCount, color: "var(--amber)", subLabel: "with discount active" },
    { label: "With Sub-units", val: allProducts.filter((p) => p.hasSubUnits).length, color: "var(--blue)", subLabel: "multi-unit products" },
  ];
  const subUnitCount = allProducts.filter((p) => p.hasSubUnits).length;
  return (
    <>
      <div className='pp__stats'>
        {stats.map((s) => (
          <div key={s.label} className='pp__stat'>
            <div className='pp__stat-label'>{s.label}</div>
            <div className='pp__stat-val' style={{ color: s.color }}>
              {s.val}
            </div>
          </div>
        ))}
      </div>

      <div className={`pp__drawer-backdrop${drawerOpen ? " open" : ""}`} onClick={() => onClose()} />

      <div className={`pp__stats-drawer${drawerOpen ? " open" : ""}`}>
        <div className='pp__drawer-handle' />
        <div className='pp__drawer-handle-row'>
          <div className='pp__drawer-title'>Product Insights</div>
          <button className='pp__drawer-close' onClick={() => onClose()}>
            <i className='ti ti-x' />
          </button>
        </div>
        <div className='pp__drawer-grid'>
          {stats.map((s) => (
            <div key={s.label} className='pp__drawer-stat'>
              <div className='pp__drawer-stat-label'>{s.label}</div>
              <div className='pp__drawer-stat-val' style={{ color: s.color }}>
                {s.val}
              </div>
              <div className='pp__drawer-stat-sub'>{s.subLabel}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
